<template>
  <div class="thousand_layout">
    <div class="chp_box">
      <div class="chp_index">
        <div class="chp_index_box">
          <div>{{ $t('base.balanceNow') }}</div>
          <div class="chp_num">{{userInfo.SumMoney}}</div>
          <div class="chp_change">
            <router-link v-if="userInfo.VerifyStatus==2" class="chp_btn" :to="{path:'/pay/chp'}">{{ $t('title.charge') }}</router-link>
            <div class="What_c">
              <span></span>
              <router-link :to="{path:'/terms/privacy?type=3'}">{{ $t('symbol.whatCHP') }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="chp_list_box" v-if="list!=''">
        <h4 class="chp_h4">{{ $t('base.chpHistory') }}</h4>
        <div class="chp_list chp_gary">
          <div>{{ $t('base.title') }}</div>
          <div>{{ $t('base.type') }}</div>
          <div>{{ $t('base.amount') }}</div>
          <div>{{ $t('base.balance') }}</div>
          <div>{{ $t('base.createTime') }}</div>
        </div>
        <div class="chp_list" v-for='(item,index) in list' :key="index">
          <!-- <div class="line_txt1">{{item.Title.indexOf("管理员后台操作")>-1?item.Describe:item.Title}}</div> -->
          <div class="line_txt1">{{item.Describe?item.Describe:''}}</div>
          <div>{{item.ConsumptionType!=2?$t('base.deduct'):$t('base.increase')}}</div>
          <div :class="item.ConsumptionType!=2?'text_red':'text_greed'">{{item.ConsumptionType!=2?'':'+'}}{{item.Money}}</div>
          <div>{{item.SumMoney}}</div>
          <div>{{item.CreateDate|setTime}}</div>
        </div>
      </div>
    </div>
    <!-- <list-pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' /> -->
  </div>
</template>
<script>
import { getInfo,getTime,getUser } from "@/api/public";
import ListPagination from '@/components/listpagination'
export default {
  name: 'chp',
  components: { ListPagination },
  data() {
    return {
      userInfo:'',
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      list:''
    }
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    }
  },
  created() {
    this.userInfo=getInfo()
    this.Consumption()
    this.getUserDetail()
  },
  mounted() {},
  methods: {
    // 获取用户详情
    /**
     * 获取用户详细信息
     * 通过接口请求获取用户的积分和总金额等信息
     * @method getUserDetail
     * @description 调用 GetUserDetail 接口获取用户详情，并更新本地用户信息
     * @returns {Promise} 返回请求结果的 Promise
     */
    getUserDetail() {
      let that = this;
      let data={'memberid':that.userInfo.MappingUserId,'token':that.userInfo.ChineseToken,'operator_id':that.userInfo.MappingUserId}
      that.$get(this.$interface.GetUserDetail,data).then(res=>{
        if(res.result!=0){
          let data=res.data;
          that.userInfo.PointCount=data.PointCount;
          that.userInfo.SumMoney=data.SumMoney;
          getUser(that.userInfo,0)
          // window.localStorage.setItem("cardUser", JSON.stringify(that.userInfo))
        }
      })
    },
    // 获取消费明细
    /**
     * 获取用户消费记录
     * @description 通过用户ID和token调用接口获取消费记录列表
     * @method Consumption
     * @returns {Promise} 返回消费记录数据列表
     * @property {Object} data - 请求参数
     * @property {String} data.memberid - 会员ID
     * @property {String} data.operator_id - 操作员ID
     * @property {String} data.token - 中文token
     * @property {Number} data.pageindex - 页码
     * @property {String} data.begindate - 开始日期
     * @property {String} data.enddate - 结束日期
     * @property {String} data.ConsumptionType - 消费类型
     */
    Consumption() {
      let that = this
      let data={memberid:that.userInfo.MappingUserId,operator_id:that.userInfo.MappingUserId,token:that.userInfo.ChineseToken,pageindex:1,begindate:'',enddate:'',ConsumptionType:''}
      this.$get(this.$interface.Consumption,data).then(res=>{
        if(res.result!=0){
          that.list=res.data
        }
        //console.log(res)
      })
    },
    // 
    pageSize(val) {
      this.ps = val
      //this.getDetailList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      //this.getDetailList();
    },
  }
}

</script>
<style scoped>
.What_c{
  display: flex;
}
.What_c span{
  width: 16px;
  height: 16px;
  background: url(../../../static/images/icon_doubt.svg) no-repeat;
  margin: 0 4px 0 0;
}
.chp_box {
  padding: 20px 0;
}

.chp_index {
  height: 177px;
  min-width: 320px;
  display: inline-block;
  background: linear-gradient(to bottom right, RGBA(139, 154, 223, 1), RGBA(96, 110, 175, 1));
  border-radius: 5px;
  overflow: hidden;
}

.chp_index_box {
  background: url(../../../static/images/Frame.svg) no-repeat;
  width: 100%;
  height: 100%;
  color: #fff;
  padding: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
}

.chp_index_box:before {
  content: "";
  background: url(../../../static/images/icon/icon_CHP.svg) no-repeat;
  width: 40px;
  height: 40px;
  top: 16px;
  right: 16px;
  position: absolute;
}

.chp_num {
  font-size: 48px;
  font-weight: bold;
}

.chp_change {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.chp_change a {
  color: #fff;
  font-size: 14px;
}

.chp_btn {
  width: 46px;
  padding: 10px 20px;
  border: 1px solid #fff;
  border-radius: 4px;
  display: inline-block;
  line-height: 1;
}

.chp_list_box {
  overflow: hidden;
}

.chp_h4 {
  font-size: 24px;
  margin-top: 40px;
  margin-bottom: 20px
}

.chp_list {
  display: flex;
  height: 48px;
  line-height: 2;
  border-bottom: 1px solid #e0e0e0;
}

.chp_list>div {
  width: 116px;
  padding: 12px 12px;
}

.chp_list>div:nth-child(1) {
  width: 332px;
  /* line-height: 1.2; */
  /* justify-content: center;
    align-items: center; */
    /* display: flex; */
}

.chp_list>div:nth-child(3),
.chp_list>div:nth-child(4) {
  text-align: right;
}

.chp_list>div:nth-child(5) {
  width: 220px;
  padding: 0;
  padding-left: 52px;
  justify-content: start;
    align-items: center;
    display: flex;
}
.chp_gary>div{
  text-align: left;
  background-color: #f7f7f7;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/chp.vue